import React, {useState} from "react";

import {useAccommodationsPage} from "./AccommodationContext";
import {useFeedbackTools} from "../../components/FeedbackTools";
import {useArchiveHomeMutation} from "./query";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';


const AccommodationSelector = () => {
    const {
        homes,
        selectedHomeName,
        onHomeSelection,
        formCreateHome,
        selectedHomeId,
        deleteHome
    } = useAccommodationsPage();

    const {showErrorNotification, askConfirmation} = useFeedbackTools();
    const archiveHomeMutation = useArchiveHomeMutation({homeId: selectedHomeId});

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const menuOpen = Boolean(menuAnchorEl);

    const handleOpen = (e) => {
        setMenuAnchorEl(e.currentTarget);
    }

    const handleSelect = (home) => {
        handleClose();
        onHomeSelection(home);
    }

    const handleClose = () => {
        setMenuAnchorEl(null);
    }

    const handleCreateHome = () => {
        handleClose();
        formCreateHome.open();
    }

    const handleArchive = () => {
        const innerArchive = async () => {
            try{
                await archiveHomeMutation.mutateAsync();
                deleteHome(selectedHomeId);
                handleClose();
            }catch(e){
                showErrorNotification(e);
            }
        }
        askConfirmation({
            title: "Elimina Struttura",
            description: `Confermando sarà eliminata la struttura selezionata e tutti gli appartamenti associati. Confermi l'eliminazione della struttura selezionata?`,
            confirmationText: 'Si',
            cancellationText: 'No',
            onConfirm: innerArchive
        });
    }

    return <>
        <Button
            id="accommodation-button"
            aria-controls={menuOpen ? 'accommodation-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={menuOpen ? 'true' : undefined}
            onClick={handleOpen}
            color="inherit"
            endIcon={<ArrowDropDownIcon/>}
        >
            { selectedHomeName ? selectedHomeName : "Seleziona casa"}
        </Button>

        <Menu
            id="accommodation-menu"
            anchorEl={menuAnchorEl}
            open={menuOpen}
            onClose={handleClose}
            MenuListProps={{'aria-labelledby': 'accommodation-button'}}>
            {
                homes.map((h, i) => <MenuItem key={i} dense onClick={() => handleSelect(h)}> {h.name} </MenuItem>)
            }
            {
                homes.length > 0 && <Divider />
            }
            <MenuItem dense onClick={handleCreateHome}>
                <ListItemIcon>
                    <AddIcon fontSize="small" />
                </ListItemIcon>
                Crea nuova casa
            </MenuItem>
            {
                selectedHomeId !== null && selectedHomeId !== undefined && <MenuItem dense onClick={handleArchive}>
                    <ListItemIcon>
                        <DeleteIcon fontSize="small"/>
                    </ListItemIcon>
                    Elimina casa
                </MenuItem>
            }
        </Menu>
    </>
}

export default AccommodationSelector;